import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const costListLocaleModule: LocaleModule = {
  name: "costList",
  messages: { en: en, it: it },
};
